var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1590_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0251 36.35V30.9832C16.0251 29.6181 17.138 28.5089 18.5168 28.4998H23.5674C24.9528 28.4998 26.0759 29.6116 26.0759 30.9832V30.9832V36.3666C26.0756 37.5256 27.0099 38.4728 28.1803 38.5H31.5474C34.904 38.5 37.625 35.8062 37.625 32.4832V32.4832V17.2162C37.6071 15.9089 36.9871 14.6814 35.9415 13.8828L24.426 4.69928C22.4086 3.10024 19.5409 3.10024 17.5235 4.69928L6.05854 13.8995C5.00895 14.6948 4.38793 15.9244 4.375 17.2329V32.4832C4.375 35.8062 7.09603 38.5 10.4526 38.5H13.8197C15.0191 38.5 15.9915 37.5374 15.9915 36.35V36.35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1590_1481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b52d1808826871cef534b8a8d8842e4a.svg";
export { ForwardRef as ReactComponent };